export class Constants {
  static hostname: any = "staging-login.able-plus.co.uk";
  static logoPath: any = "assets/img/able/NewEra_ABLE_Master_Logo_CMYK.png";
  static maxUsersList: number = 5;
  static minUsersList: number = 0;
  static localStorage_ListUsers = "LastUsers";
  static localStorage_currentUser = "currentUser";
  static appStoreImage: string = "assets/img/download_on_app_store.png";
  static googlePlayImage: string = "assets/img/download_on_google_play.png";
  static maxNo2FACodeSend: number = 2;
  static ulsterOrganisationId: any = "35d98131-e3d0-45cf-b721-471ca4825b27";
  static ulsterLogoPath: any = "../../../assets/img/ulster/ulster-university-blue.png";
  static lululemonOrganisationId: any = '8f6a342f-769f-46ce-97fd-af1086c81c4e';
  static lululemonLogoPath: any = "../../../assets/img/lululemon/c3-logo_web.png";
  static newEraTechLogo: any = "../../../assets/img/newera-tech-logo.png";
}
